import type { QuickSettings as QuickSettingsType } from '../../components/TenderDetails/types';
import type { ProposalHeading } from '../../types/proposal';
import type { Tender } from '../../types/tender';

const EMPTY_ARRAY: never[] = [];

export const useStructureExtracted = (
  setProposalStructure: React.Dispatch<React.SetStateAction<ProposalHeading[]>>,
  tender: Tender | null,
  quickSettings: QuickSettingsType,
  showSnackbar: (
    message: string,
    severity: 'success' | 'error' | 'warning' | 'info',
    duration?: number
  ) => void
) => {
  const handleLoadExtractedStructure = (mode?: 'standard' | 'hybrid'): void => {
    const hasForms = (tender?.detectedForms || EMPTY_ARRAY).length > 0;
    const effectiveFormatMode = hasForms
      ? quickSettings.draftFormatMode || 'narrative'
      : 'narrative';
    const targetMode = mode || effectiveFormatMode;

    let structureToLoad = tender?.extractedStructure;

    if (
      targetMode === 'hybrid' &&
      tender?.hybridExtractedStructure &&
      tender.hybridExtractedStructure.length > 0
    ) {
      structureToLoad = tender.hybridExtractedStructure;
    }

    if (structureToLoad && structureToLoad.length > 0) {
      // Filter out redundant Executive Summary from AI-generated sections
      // because they are either natively handled by the template as static pins, or the user
      // explicitly did not include them in their template and does not want them.
      let finalStructure = [...structureToLoad];

      finalStructure = finalStructure.filter((item) => {
        const title = item.title.toLowerCase().replace(/[^a-z0-9]/g, '');
        return !title.includes('executivesummary');
      });

      setProposalStructure(finalStructure);
      showSnackbar(
        `Extracted ${targetMode === 'hybrid' ? 'hybrid narrative ' : ''}structure loaded!`,
        'success'
      );
    } else {
      showSnackbar('No extracted structure available.', 'warning');
    }
  };

  return {
    handleLoadExtractedStructure,
  };
};
